import { render } from "./ActiveDemoTic.vue?vue&type=template&id=102f4948"
import script from "./ActiveDemoTic.vue?vue&type=script&lang=js"
export * from "./ActiveDemoTic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__